import React, { FC } from 'react';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { RatingElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './reviews.scss';

// Store entities
import { getCurrentCounsellorState } from '../../../../store/current-counsellor/current-counsellor.selectors';

type TReviewsProps = {};

export const Reviews: FC<TReviewsProps> = (
  {}: TReviewsProps
) => {

  const { counsellor, loading, error } = useSelector(getCurrentCounsellorState);

  return (
    <div className="reviews">
      <div className="reviews--header">
        <div className="header-title">
          Reviews
        </div>
        <div className="header-rating">
          <RatingElement defaultValue={ counsellor?.rating } disabled={ true }
                         size={ 'small' }/> { counsellor?.reviews_count } Reviews
        </div>
      </div>
    </div>
  );
}
